import { useMediaQuery, useTheme } from '@material-ui/core';
import { Sidebar } from 'components/Sidebar';
import { Header } from 'components/Header';
import React, { Suspense, useState } from 'react';
import { Backdrop } from '@room-match/shared-ui-components';

import { useStyles } from './Layout.style';

type Props = {
  children: React.ReactNode;
};
const Layout: React.FC<Props> = ({ children }) => {
  const classes = useStyles();
  const theme = useTheme();
  const screenLarge = useMediaQuery(theme.breakpoints.up('md'), {
    noSsr: true,
  });
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [isDrawerCollapse, setIsDrawerCollapse] = useState(!screenLarge);
  const handleMobileDrawer = () => {
    setIsMobileDrawerOpen(!isMobileDrawerOpen);
  };

  const toggleDrawerCollapse = () => {
    setIsDrawerCollapse((isCollapse) => !isCollapse);
  };

  return (
    <div className={classes.root}>
      <Header handleDrawerToggle={handleMobileDrawer} isDrawerCollapse={isDrawerCollapse} />
      <Sidebar
        handleMobileDrawer={handleMobileDrawer}
        isMobileDrawerOpen={isMobileDrawerOpen}
        isDrawerCollapse={isDrawerCollapse}
        toggleDrawerCollapse={toggleDrawerCollapse}
      />

      <main className={classes.content}>
        <div className={classes.toolbar} style={{ minHeight: '60px' }} />
        <Suspense fallback={<Backdrop />}>
          <>{children}</>
        </Suspense>
      </main>
    </div>
  );
};

export default Layout;
